// constants.js

// --- API Keys ---
export const API_KEY = "AIzaSyBRQwYPeru_FEcLCkVBweQQRjPLBXkzJDs";
export const TURNSTILE_SITE_KEY = "0x4AAAAAABCZRvADQrVNADOF"; // Added Turnstile Site Key here

// --- Map Constants ---
export const DEFAULT_MAP_CENTER = { lat: 47.646291, lng: -122.4998 }; // Bainbridge Island, WA

// --- Form Stepper Steps ---
export const STEPS = [
  "Basic Info",
  "Location",
  "Dive Details",
  "Additional Info",
];

// --- Form Field Options ---
export const ENVIRONMENTS = [
  { value: "Unknown", label: "Unknown" },
  { value: "Ocean-sea", label: "Ocean/Sea" }, // Improved label for clarity
  { value: "Lake-quarry", label: "Lake/Quarry" }, // Improved label
  { value: "Cave-cavern", label: "Cave/Cavern" }, // Improved label
  { value: "Under-ice", label: "Under Ice" }, // Improved label
  { value: "Other", label: "Other" },
  // Consider removing 'undefined' as a user-selectable option unless explicitly needed for a specific reason
  // { value: "undefined", label: "Undefined" },
];

export const PLATFORMS = [
  { value: "beach-shore", label: "Beach/Shore" }, // Improved label
  { value: "pier", label: "Pier" },
  { value: "small-boat", label: "Small Boat" },
  { value: "charter-boat", label: "Charter Boat" }, // Corrected spelling
  { value: "live-aboard", label: "Live Aboard" },
  { value: "barge", label: "Barge" },
  { value: "other", label: "Other" },
];

// --- Rating/Sentiment Icons (if used across the app, otherwise keep with rating component) ---
export const CUSTOM_ICONS = {
  1: {
    icon: "SentimentVeryDissatisfied",
    label: "Very Dissatisfied",
    color: "error",
  },
  2: {
    icon: "SentimentDissatisfied",
    label: "Dissatisfied",
    color: "error",
  },
  3: {
    icon: "SentimentSatisfied",
    label: "Neutral",
    color: "warning",
  },
  4: {
    icon: "SentimentSatisfiedAltOutlined",
    label: "Satisfied",
    color: "success",
  },
  5: {
    icon: "SentimentVerySatisfied",
    label: "Very Satisfied",
    color: "success",
  },
};

// --- Initial Form State (Moved to useDivesiteForm hook for better encapsulation) ---
// It's generally better to define the initial state directly within the
// custom hook (e.g., `useDivesiteForm.js`) that manages that state.
// This ensures the initial state is tightly coupled with the hook's logic
// and avoids potential circular dependencies or confusion if this constant
// is imported elsewhere where it's not strictly necessary.
//
// If you *really* need to access the bare initial state externally for
// testing or specific scenarios, you can export it, but typically it's
// best kept within the hook.
/*
export const initialFormState = {
  name: "",
  location: "",
  city: "",
  province: "",
  province_short: "",
  country: "",
  country_short: "",
  divesitePara: "",
  diveDescription: "",
  environment: "",
  platform: "",
  depthRange: [5, 16],
  surfaceSwimDistance: 0,
  mapCenter: DEFAULT_MAP_CENTER,
  markerPosition: DEFAULT_MAP_CENTER,
  mediaImages: [], // Initialize as an empty array
  heroImage: { file: null, description: "" }, // Initialize as object
  diagramImage: { file: null, description: "" }, // Initialize as object
  closestTideStation: "",
  slog: 0,
};
*/
